"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/EnterEmail/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _amplitude = require('web/services/amplitude'); var _amplitude2 = _interopRequireDefault(_amplitude);
var _EnterEmail = require('./EnterEmail'); var _EnterEmail2 = _interopRequireDefault(_EnterEmail);

// /welcome: the staff sign-up start. Patients follow "Patient sign-in" to the
// login page's Patient side, which is when SIGN_UP_PATIENT fires.
const SignupScreen = () => {
  const onPatientSignIn = _react.useCallback.call(void 0, () => _amplitude2.default.logEvent("SIGN_UP_PATIENT"), [])
  return _react2.default.createElement(_EnterEmail2.default, { onPatientSignIn: onPatientSignIn, __self: this, __source: {fileName: _jsxFileName, lineNumber: 10}} )
}

exports. default = SignupScreen
